@if (showLoginAnimation) {
  <div
    class="background-wrapper"
    [class.active]="showLoginAnimation"
    @loginBackgroundAnimation
  >
    <!--<img
      [src]="'./assets/backgrounds/auth_' + backgroundRandomizer() + '.webp'"
      alt=""
    />-->
  </div>
}
@if (!showLoginAnimation) {
  @if (loggedIn$ | async) {
    <ng-container>
      <div
        class="load-indicator"
        [class.active]="routerService.loading$ | async"
      ></div>
      <app-sidenav tourAnchor="sidenav"></app-sidenav>
      <div
        tourAnchor="body"
        class="app-wrapper"
        [class.navigation-open]="sidenavOpen$ | async"
        [class.kira-open]="companionService.companionOpen()"
      >
        <div class="app-shell-top">
          <app-topnav tourAnchor="topnav"></app-topnav>
        </div>
        @if (routerService.loading$ | async; as loading) {
          <div class="view-loader">
            <app-view-loader [loading]="loading"></app-view-loader>
          </div>
        } @else {
          <div class="router-wrapper mt-2">
            <router-outlet #outlet="outlet"></router-outlet>
          </div>
        }
        @if (isAdmin$ | async) {
          <app-onboarding-modal></app-onboarding-modal>
        }
        @if (userAccount$ | async; as userAccount) {
          <app-nps-modal [userAccount]="userAccount"></app-nps-modal>
        }
        <app-tfa-block-modal
          (triggerAddMethodModal)="addMethodModal.newMethodModal.open()"
          #tfaBlockModal
        >
        </app-tfa-block-modal>
        <app-add-tfa-modal
          (methodAdded)="tfaBlockModal.tfaRequiredBlockedModal.close()"
          #addMethodModal
        >
        </app-add-tfa-modal>
      </div>
      <app-tos-modal></app-tos-modal>
      <app-credits-booking-modal></app-credits-booking-modal>
      <app-credits-log-modal></app-credits-log-modal>
      <app-invoice-billing-modal></app-invoice-billing-modal>
      <app-release-notes-modal></app-release-notes-modal>
    </ng-container>
  } @else {
    <div class="authentication" @authenticationAnimation>
      <div class="auth-shell">
        <aside class="shell-right" aria-label="Branding">
          <div
            class="auth-hero"
            [class.is-dark]="themingService.theme === 'dark'"
          >
            <!--<img
            class="hero-bg"
            [src]="'./assets/backgrounds/auth_' + backgroundRandomizer() + '.webp'"
            alt=""
            loading="lazy"
          />-->
            <app-mesh-gradient></app-mesh-gradient>
            <app-auth-hero-carousel></app-auth-hero-carousel>
          </div>
        </aside>

        <div class="shell-left" aria-label="Authentication content">
          <div class="shell-top" aria-label="Brand and language">
            <img
              class="shell-logo"
              [src]="
                themingService.theme === 'dark'
                  ? './assets/img/logos/titled/white_titled_white.png'
                  : './assets/img/logos/titled/dark_titled_dark.png'
              "
              alt="Catch"
              loading="lazy"
            />

            <div class="shell-top-actions">
              <div class="shell-theme">
                <ct-lib-dropdown
                  [dropdown]="themeDropdown"
                  [autowidth]="true"
                  [alignment]="'right'"
                  [closeOnClick]="true"
                >
                  <button
                    type="button"
                    class="shell-language-trigger"
                    [attr.aria-label]="
                      'company-tool.views.authentication.theme.aria-trigger'
                        | transloco
                    "
                  >
                    @if (themingService.theme === 'dark') {
                      <fa-icon
                        [icon]="fontawesomeService.light.moon"
                        size="lg"
                      ></fa-icon>
                    } @else {
                      <fa-icon
                        [icon]="fontawesomeService.light.brightnessLow"
                        size="lg"
                      ></fa-icon>
                    }
                    <span class="shell-language-label">
                      @if (themingService.theme === 'dark') {
                        {{
                          'company-tool.views.authentication.theme.dark'
                            | transloco
                        }}
                      } @else {
                        {{
                          'company-tool.views.authentication.theme.light'
                            | transloco
                        }}
                      }
                    </span>
                  </button>
                </ct-lib-dropdown>
                <ng-template #themeDropdown>
                  <div class="shell-language-panel">
                    <ul
                      class="shell-language-menu"
                      role="menu"
                      [attr.aria-label]="
                        'company-tool.views.authentication.theme.menu-label'
                          | transloco
                      "
                    >
                      <li role="none">
                        <button
                          type="button"
                          class="shell-language-option shell-theme-option"
                          role="menuitemradio"
                          [attr.aria-checked]="themingService.mode === 'light'"
                          (click)="setAuthThemeMode('light')"
                        >
                          <span class="shell-theme-option-main">
                            <fa-icon
                              [icon]="fontawesomeService.light.brightnessLow"
                              size="lg"
                            ></fa-icon>
                            <span>{{
                              'company-tool.views.authentication.theme.light'
                                | transloco
                            }}</span>
                          </span>
                          @if (themingService.mode === 'light') {
                            <span
                              class="shell-language-dot"
                              aria-hidden="true"
                            ></span>
                          }
                        </button>
                      </li>
                      <li role="none">
                        <button
                          type="button"
                          class="shell-language-option shell-theme-option"
                          role="menuitemradio"
                          [attr.aria-checked]="themingService.mode === 'dark'"
                          (click)="setAuthThemeMode('dark')"
                        >
                          <span class="shell-theme-option-main">
                            <fa-icon
                              [icon]="fontawesomeService.light.moon"
                              size="lg"
                            ></fa-icon>
                            <span>{{
                              'company-tool.views.authentication.theme.dark'
                                | transloco
                            }}</span>
                          </span>
                          @if (themingService.mode === 'dark') {
                            <span
                              class="shell-language-dot"
                              aria-hidden="true"
                            ></span>
                          }
                        </button>
                      </li>
                      <li role="none">
                        <button
                          type="button"
                          class="shell-language-option shell-theme-option"
                          role="menuitemradio"
                          [attr.aria-checked]="themingService.mode === 'auto'"
                          (click)="setAuthThemeMode('auto')"
                        >
                          <span class="shell-theme-option-main">
                            <fa-icon
                              [icon]="fontawesomeService.light.magic"
                              size="lg"
                            ></fa-icon>
                            <span>{{
                              'company-tool.views.authentication.theme.system'
                                | transloco
                            }}</span>
                          </span>
                          @if (themingService.mode === 'auto') {
                            <span
                              class="shell-language-dot"
                              aria-hidden="true"
                            ></span>
                          }
                        </button>
                      </li>
                    </ul>
                  </div>
                </ng-template>
              </div>

              <div class="shell-language">
                <ct-lib-dropdown
                  [dropdown]="languageDropdown"
                  [autowidth]="true"
                  [alignment]="'right'"
                  [closeOnClick]="true"
                >
                  <button
                    type="button"
                    class="shell-language-trigger"
                    aria-label="Change language"
                  >
                    <fa-icon
                      [icon]="fontawesomeService.light.globe"
                      size="lg"
                    ></fa-icon>
                    <span class="shell-language-label">
                      {{ languageService.currentLanguage?.name ?? 'Language' }}
                    </span>
                  </button>
                </ct-lib-dropdown>
                <ng-template #languageDropdown>
                  <div class="shell-language-panel">
                    <ul
                      class="shell-language-menu"
                      role="menu"
                      aria-label="Available languages"
                    >
                      @for (lang of languages; track lang.value) {
                        <li role="none">
                          <button
                            type="button"
                            class="shell-language-option"
                            role="menuitemradio"
                            [attr.aria-checked]="
                              languageService.currentLanguage?.value ===
                              lang.value
                            "
                            (click)="languageService.setLanguage(lang.value)"
                          >
                            <span class="shell-language-name">{{
                              lang.name
                            }}</span>
                            @if (
                              languageService.currentLanguage?.value ===
                              lang.value
                            ) {
                              <span
                                class="shell-language-dot"
                                aria-hidden="true"
                              ></span>
                            }
                          </button>
                        </li>
                      }
                    </ul>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>

          <div class="shell-body">
            @if (maintenanceInfo() !== null) {
              <ct-lib-info-banner type="warning">
                <p>
                  {{
                    'company-tool.views.authentication.maintenance-info'
                      | transloco
                        : {
                            date: maintenanceInfo().date,
                            time: maintenanceInfo().time,
                          }
                  }}
                </p>
              </ct-lib-info-banner>
            }
            <router-outlet></router-outlet>
          </div>

          <div class="shell-meta" aria-label="Copyright and version">
            <p>Copyright &copy; catchHR {{ year }} | {{ version }}</p>
          </div>
        </div>
      </div>
    </div>
  }
} @else {
  <div class="login-animation" @loginAnimation>
    @if (themingService.theme === 'dark') {
      <img src="./assets/img/logos/solid/white.png" />
    } @else {
      <img src="./assets/img/logos/solid/dark.png" />
    }
    <h1>
      {{
        'company-tool.views.authentication.login.animation.welcome' | transloco
      }}
    </h1>
  </div>
}

<div class="toast-container">
  @if ((connectionService.connected$ | async) === false) {
    <ct-lib-toast
      [toast]="{ type: 'alert', value: 'company-tool.other.no-connection' }"
      [fixed]="true"
      @toastInOut
    >
    </ct-lib-toast>
  }
  @for (toast of toastsService.toasts; track toast.id) {
    <ct-lib-toast
      [toast]="toast"
      (onDestroy)="toastsService.destroyToast($event)"
      @toastInOut
    >
    </ct-lib-toast>
  }
</div>

<!-- Onboarding Tour -->

<div class="centered-tour-element" tourAnchor="tour-centered"></div>
<tour-step-template>
  <ng-template let-step="step">
    <div class="ct-card tour-card" (click)="$event.stopPropagation()">
      <!--

      [style.width]="step.stepDimensions?.width"
      [style.min-width]="step.stepDimensions?.minWidth"
      [style.max-width]="step.stepDimensions?.maxWidth"
      -->
      <b>{{ step.title | transloco }}</b>
      <p>{{ step.content | transloco }}</p>
      <div class="tour-buttons">
        <app-button variant="link" (click)="uiTourService.end()">
          {{ step.endBtnTitle | transloco }}
        </app-button>
        <div>
          @if (uiTourService.hasPrev(step)) {
            <app-button
              variant="white-grey"
              [iconStart]="fontawesomeService.light.chevronLeft"
              (click)="uiTourService.prev()"
            >
            </app-button>
          }
          @if (uiTourService.hasNext(step)) {
            <app-button (click)="uiTourService.next()">
              {{ step.nextBtnTitle | transloco }}
            </app-button>
          } @else if (step.stepId === 'dashboard-6') {
            <app-button (click)="tourService.endTour(true)">
              {{ 'company-tool.onboarding.tour.1.steps.6.cta' | transloco }}
            </app-button>
          } @else {
            <app-button (click)="uiTourService.end()">
              {{ 'company-tool.onboarding.tour.buttons.end' | transloco }}
            </app-button>
          }
        </div>
      </div>
    </div>
  </ng-template>
</tour-step-template>
